import { createContext } from 'react';

export const AuthContext = createContext<ContextProps>({
	isSupported: false,
	isAuthenticated: false,
});

interface ContextProps {
	accessToken?: string;
	refreshToken?: string;
	isSupported: boolean;
	isAuthenticated: boolean;
}
